import { IDENTITY_PROVIDERS } from '@24i/nxg-core-utils/src/constants';
import { FlowIDService } from '../../services/auth';
import { cleengSignOut } from '../cleeng/auth';

const flowIDProviderLogout = () => FlowIDService.logout();

export const providerLogout = async (provider?: IDENTITY_PROVIDERS): Promise<void | null> => {
    switch (provider) {
        case IDENTITY_PROVIDERS.FLOWID:
        case IDENTITY_PROVIDERS.FLOWID_V2:
            return flowIDProviderLogout();
        case IDENTITY_PROVIDERS.CLEENG:
        case IDENTITY_PROVIDERS.CLEENG_V2:
            return cleengSignOut();
        default:
            return null;
    }
};
